// extracted by mini-css-extract-plugin
module.exports = {"lightTabs":"LrvTabs_lightTabs__8C6bg","darkTabs":"LrvTabs_darkTabs__2-Pgu"};